(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const containerSelector = '.cart-drawer__accelerated-checkout';
    const walletSelector = 'shopify-accelerated-checkout-cart';
    const mobileQuery = window.matchMedia('(max-width: 699px)');
    const skeleton = '<div class="wallet-button-wrapper"><ul class="wallet-cart-grid wallet-cart-grid--skeleton" role="list" data-shopify-buttoncontainer="true"><li data-testid="grid-cell" class="wallet-cart-button-container"><div class="wallet-cart-button wallet-cart-button__skeleton" role="button" disabled aria-hidden="true">&nbsp;</div></li></ul></div>';

    const getContainers = (scope) => {
      const containers = [];

      if (scope instanceof Element && scope.matches(containerSelector)) {
        containers.push(scope);
      }

      if (scope.querySelectorAll) {
        containers.push(...scope.querySelectorAll(containerSelector));
      }

      return containers;
    };

    const restoreNativeLayout = (container) => {
      container.querySelector('.cart-drawer__wallet-grid')?.remove();

      const source = container.querySelector(`${walletSelector}[data-emolo-wallet-source]`);

      if (source) {
        source.hidden = false;
        source.removeAttribute('data-emolo-wallet-source');
      }
    };

    const createWallet = (source, config) => {
      const inertDocument = document.implementation.createHTMLDocument('');
      const wallet = inertDocument.createElement(source.localName);

      for (const attribute of source.attributes) {
        if (attribute.name !== 'hidden' && attribute.name !== 'data-emolo-wallet-source') {
          wallet.setAttribute(attribute.name, attribute.value);
        }
      }

      wallet.setAttribute('wallet-configs', JSON.stringify([config]));
      wallet.setAttribute('data-emolo-wallet-clone', '');
      wallet.innerHTML = skeleton;

      return document.adoptNode(wallet);
    };

    const applyMobileGrid = (container) => {
      if (!mobileQuery.matches) {
        restoreNativeLayout(container);
        return;
      }

      if (container.querySelector('.cart-drawer__wallet-grid')) {
        return;
      }

      const content = container.querySelector('.dynamic-checkout__content') || container;
      const source = content.querySelector(`${walletSelector}:not([data-emolo-wallet-clone])`);

      if (!source) {
        return;
      }

      let configs;

      try {
        configs = JSON.parse(source.getAttribute('wallet-configs') || '[]');
      } catch {
        return;
      }

      if (!Array.isArray(configs) || configs.length < 2) {
        return;
      }

      const grid = document.createElement('div');
      grid.className = 'cart-drawer__wallet-grid';

      configs.forEach((config, index) => {
        const cell = document.createElement('div');
        cell.className = 'cart-drawer__wallet-cell';

        if (configs.length % 2 === 1 && index === configs.length - 1) {
          cell.classList.add('cart-drawer__wallet-cell--wide');
        }

        cell.append(createWallet(source, config));
        grid.append(cell);
      });

      source.setAttribute('data-emolo-wallet-source', '');
      source.hidden = true;
      content.append(grid);
    };

    const refreshLayout = (scope = document) => {
      getContainers(scope).forEach(applyMobileGrid);
    };

    const scheduleRefresh = (scope = document) => {
      window.requestAnimationFrame(() => refreshLayout(scope));
    };

    document.addEventListener('cart-drawer:refreshed', (event) => scheduleRefresh(event.target));
    document.addEventListener('shopify:section:load', (event) => scheduleRefresh(event.target));
    mobileQuery.addEventListener('change', () => scheduleRefresh());

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scheduleRefresh(), { once: true });
    } else {
      scheduleRefresh();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => value
      .toLocaleLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();

    const initialize = (root) => {
      if (!root || root.dataset.storeLocatorReady === "true") return;

      const form = root.querySelector("[data-store-search]");
      const input = root.querySelector("[data-store-search-input]");
      const clearButton = root.querySelector("[data-store-clear]");
      const count = root.querySelector("[data-store-count]");
      const empty = root.querySelector("[data-store-no-results]");
      const cards = [...root.querySelectorAll("[data-store-card]")];

      if (!form || !input || !count || cards.length === 0) return;
      root.dataset.storeLocatorReady = "true";

      const update = () => {
        const query = normalize(input.value);
        let visible = 0;

        cards.forEach((card) => {
          const matches = normalize(card.dataset.storeSearchable || "").includes(query);
          card.hidden = !matches;
          if (matches) visible += 1;
        });

        count.textContent = (count.dataset.resultTemplate || "[count]").replace("[count]", visible);
        if (empty) empty.hidden = visible !== 0;
        if (clearButton) clearButton.hidden = query.length === 0;
      };

      form.addEventListener("submit", (event) => event.preventDefault());
      input.addEventListener("input", update);
      clearButton?.addEventListener("click", () => {
        input.value = "";
        update();
        input.focus();
      });

      update();
    };

    const boot = (scope = document) => {
      if (scope.matches?.("[data-store-locator]")) initialize(scope);
      scope.querySelectorAll?.("[data-store-locator]").forEach(initialize);
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => boot());
    } else {
      boot();
    }

    document.addEventListener("shopify:section:load", (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
